enum AnalyticEventValues {
    embed = 'embed',
    embed_ktb = 'embed_ktb',
    export = 'download',
    exportAll = 'export_all_button',
    exportIcon = 'export_icon',
    filters = 'filters',
    copy = 'copy_icon',
    youtube = 'youtube_icon',
    feedback = 'feedback',
    getAccess = 'get_access',
}

export default AnalyticEventValues;
